<template>
    <div :class="preCls + 'content-box'">
        <div :class="preCls + 'filter'" style="margin-bottom: 20px">
            <Select
                style="width: 150px; margin-right: 20px"
                placeholder="功能模块"
                clearable
                v-model="filter.module"
                @on-change="search"
            >
                <Option
                    v-for="item in dict.resourceModule.toList()"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.text }}</Option
                >
            </Select>
            <Select
                style="width: 150px; margin-right: 20px"
                placeholder="执行结果"
                clearable
                v-model="filter.result"
                @on-change="search"
            >
                <Option
                    v-for="item in enums.isSuccess.toList()"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.text }}</Option
                >
            </Select>

            <filter-date-range
                :startDate.sync="filter.startDate"
                :endDate.sync="filter.endDate"
                @on-change="search"
            ></filter-date-range>
        </div>

        <table-tool-bar>
            <template slot="left">
                <table-searcher
                    placeholder="请输入登录名,ip"
                    style="margin-left: 10px"
                    v-model="filter.keyword"
                    @search="search"
                    >搜索</table-searcher
                >
            </template>
        </table-tool-bar>

        <Table
            ref="mt"
            :columns="columns"
            :data="page.list"
            :loading="loading"
            :height="mtHeight"
        >
            <template v-slot:result="{ row }">
                <div :class="row.result == '失败' ? 'isRed' : 'isNo'">
                    {{ row.result }}
                </div>
            </template>
        </Table>

        <table-pager
            :total="page.totalCount"
            :pageSize.sync="filter.pageSize"
            :pageNo.sync="filter.page"
            @change="fetch"
        >
        </table-pager>
    </div>
</template>

<script>
import Dict from '_u/dict'
import { optrList } from '@/api/log-optr'
import { ymdL } from '_u/helper'
import { mapCache } from '@/plugins/vux-data-cache'
import FilterDateRange from '_v/components/filter/filter-date-range'

export default {
    name: 'sys-optr',
    components: {
        FilterDateRange,
    },
    data() {
        return {
            page: {
                totalCount: 0,
                list: [],
            },
            enums: {
                isSuccess: this.$enum.get('isSuccess'), // 成功还是失败
            },
            dict: {
                resourceModule: Dict.NULL, // resource_module
            },
            loading: false,
            mtHeight: 360,
        }
    },
    computed: {
        ...mapCache({
            filter: 'optrFilter', //将要缓存的改成本地命名
        }),
        columns() {
            return [
                {
                    type: 'index',
                    width: 80,
                    title: '序号',
                    align: 'center',
                },
                {
                    title: '登录名',
                    key: 'username',
                    align: 'left',
                    minWidth: 120,
                },
                {
                    title: '操作',
                    key: 'title',
                    align: 'left',
                    minWidth: 180,
                    tooltip: true,
                },
                {
                    title: 'ip',
                    key: 'ip',
                    align: 'center',
                    minWidth: 120,
                },
                {
                    title: '创建时间',
                    key: 'createTime',
                    align: 'center',
                    minWidth: 150,
                },

                {
                    title: '执行结果',
                    key: 'result',
                    align: 'center',
                    minWidth: 120,
                    slot: 'result',
                },
                {
                    title: '备注',
                    key: 'stack',
                    align: 'left',
                    minWidth: 120,
                    tooltip: true,
                },
            ]
        },
    },
    created() {
        this.fetch()
    },
    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80
        })
    },
    methods: {
        fetch() {
            this.loading = true
            Promise.all([optrList(this.filter), Dict.get(['resource_module'])])
                .then((args) => {
                    var [view, dictGroup] = args

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name]
                    })
                    this.setPageData(view.data)
                })
                .finally(() => (this.loading = false))
        },
        search() {
            this.filter.page = 1
            this.fetch()
        },
        setPageData(data) {
            data.page.list.forEach((v) => {
                v.createTime = ymdL(v.createTime)
                v.result = this.enums.isSuccess.getName(v.result)
            })
            this.page.list = data.page.list
            this.page.totalCount = parseInt(data.page.totalCount)
        },
    },
}
</script>

<style lang="less" scoped>
.isRed {
    color: rgb(217, 0, 27);
}
</style>
